import {SODeleteSubscription} from '../../core/subscription/so-delete-subscription';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteSubscription extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteSubscription;
}